import HallSelectField from "./hall-select-field";

import "./hall-fields.scss";


const HallFields = {
    Select : HallSelectField
};

export default HallFields;